<template>
  <div class="modal" v-if="brandSheet.id">
    <v-dialog :value="value" @input="$emit('input')" fullscreen transition="fade-transition">
      <v-card class="brand-fact-sheet-view-card" tile transition="fade-transition">
      <v-toolbar 
        class="mb-12"
        color="secondary"
        elevate-on-scroll>
        <v-toolbar-title class="headline" v-if="isStoryTell">Brand Fact Sheet - {{brandSheet.clientName}}</v-toolbar-title>
        <v-toolbar-title class="headline" v-if="isUGC">Brand Fact Sheet - {{brandSheet.campaignName}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar> 
      <v-container class="ims-modal-body brand-fact-sheet-view-body" fluid v-if="brandSheet.type">
        <v-form ref="feedbackform" v-model="valid" lazy-validation>
          <!-- Start Story Tell -->
          <v-layout wrap justify-center mb-2 v-if="isStoryTell">
            <v-flex xs12 md7 class="content">
              <v-row>
                <v-col cols="12" class="text-center pb-0">
                  <div class="avatar-logo">
                    <img :src="brandSheetLogo" alt="Logo" />
                  </div>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <h2 class="form-title">STORYTELL - BRAND FACT SHEET</h2>
                </v-col>
              </v-row>
              <v-row class="mb-4">
                <v-col cols="12" class="text-center pb-0">
                  <v-img src="/static/img/brand_sheet/storytell_bg.jpg" ></v-img>
                </v-col>
              </v-row>
              <!-- Use separate sections rather than array lists for easier fields update -->
              <!-- Start Section One -->
              <v-row>
                <v-col cols="12" class="text-center pb-0">
                  <p class="h4 font-weight-bold mb-0">{{brandSheetFormSections.sectionOne.title}}</p>
                </v-col>
                <v-col cols="12" class="text-center pb-0">
                  <p class="h4 font-weight-bold mb-0">{{brandSheetFormSections.sectionOne.subtitle}}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-layout wrap>
                    <v-flex :class="field.class ? field.class : 'xs12 md6'" v-for="(field, index) in brandSheetFormSections.sectionOne.fields" :key="index">
                      <div>
                        <p class="h4 font-weight-bold mb-2" v-if="field.label !== ''">{{field.label}} <span class="red--text" v-if="field.required">*</span></p>
                        <p v-else class="form-label"></p>
                        <p v-html="showFieldValue(brandSheet[field.name], field.name)"></p>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row>
              <!-- End Section One -->
                          
              <!-- Start Section Two -->
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">{{brandSheetFormSections.sectionTwo.title}}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-layout wrap>
                    <v-flex :class="field.class ? field.class : 'xs12 md6'" v-for="(field, index) in brandSheetFormSections.sectionTwo.fields" :key="index">
                      <div>
                        <p class="h4 font-weight-bold mb-2" v-if="field.label !== ''">{{field.label}} <span class="red--text" v-if="field.required">*</span></p>
                        <p v-else class="form-label"></p>
                        <p v-html="showFieldValue(brandSheet[field.name], field.name)"></p>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row>
              <!-- End Section Two -->

              <!-- Start Section Three -->
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">{{brandSheetFormSections.sectionThree.title}}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-layout wrap>
                    <v-flex :class="field.class ? field.class : 'xs12 md6'" v-for="(field, index) in brandSheetFormSections.sectionThree.fields" :key="index">
                      <div>
                        <p class="h4 font-weight-bold mb-2" v-if="field.label !== ''">{{field.label}} <span class="red--text" v-if="field.required">*</span></p>
                        <p v-else class="form-label"></p>
                        <p v-html="showFieldValue(brandSheet[field.name], field.name)" v-if="field.type === 'textbox' || field.type === 'textarea' || field.type === 'select'"></p>
                        <v-layout wrap v-if="field.type === 'checkbox'">
                          <p v-if="brandSheet[field.name].length === 0">-</p>
                          <v-flex xs12 md12 v-for="age in field.detailFields.filter(v => brandSheet[field.name].includes(v.value))" :key="age.key">
                            <p>{{age.label}}</p>
                          </v-flex>
                        </v-layout>
                        <div v-if="field.type === 'file'">
                          <v-row v-if="brandSheet[field.name].length > 0">
                            <v-col cols="12" sm="12" md="2" lg="1" v-for="(item, index) in brandSheet[field.name]" :key="index" align="center">                   
                              <a v-if="item.type.indexOf('pdf') !== -1" :href="item.url" target="_blank">
                                <v-img
                                    width="67" height="85"
                                    src="/static/img/pdf.png"
                                    aspect-ratio="1"
                                  ></v-img>
                              </a>                                                                                                               
                              <a v-if="item.type.indexOf('ppt') !== -1" :href="item.url" target="_blank">
                                <v-img
                                    width="67" height="85"
                                    src="/static/img/ppt.png"
                                  ></v-img>
                              </a>
                              <a v-if="item.type.indexOf('doc') !== -1" :href="item.url" target="_blank">
                                <v-img
                                    width="67" height="85"
                                    src="/static/img/doc.png"
                                  ></v-img>
                              </a>
                              <a v-if="item.type.indexOf('text') !== -1" :href="item.url" target="_blank">
                                <v-img
                                    width="67" height="85"
                                    src="/static/img/text.png"
                                  ></v-img>
                              </a>     
                              <a v-if="item.type.indexOf('image') !== -1" :href="item.url" target="_blank">
                                <v-img                   
                                  width="67"
                                  height="85"
                                  :src="item.url"
                                  :lazy-src="item.url"                                  
                                  class="grey lighten-2"
                                  aspect-ratio="1"
                                ></v-img>
                              </a>              
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row>
              <!-- End Section Three -->
            </v-flex>
          </v-layout>
          <!-- End Story Tell -->

          <!-- Start AOK -->
          <v-layout wrap justify-center mb-2 v-if="isAOK">
            <v-flex xs12 md7 class="content">
              <v-row>
                <v-col cols="12" class="pb-0">
                  <div class="avatar-logo">
                    <img :src="brandSheetLogo" alt="Logo" />
                  </div>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <h2 class="form-title">KOBE Uncut - BRAND FACT SHEET</h2>
                </v-col>
              </v-row>
              <v-row class="mb-4">
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">{{brandSheetAOKFormSections.sectionOne.title}}</p>
                </v-col>
              </v-row>
              <v-row class="mb-4">
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">{{brandSheetAOKFormSections.sectionOne.subtitle}}</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-img src="/static/img/brand_sheet/aok_bg.png" ></v-img>
                </v-col>
              </v-row>
              <!-- Start Section One -->
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">LEAD TIME</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">14 days upon receiving this brand fact sheet and logistics from the client.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">TIME/DATE OF PUBLISH</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">Creators are free to post at any preferred time and day during the campaign period.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">SELECTION CRITERIA</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0 pb-2">Profiles proposed will be screened for audience credibility on KOBE Patented Influencer Management System (IMS)</p>
                  <p class="mb-0">For niche requirements (for example, ethnicity, professions) , please opt for storytell packages instead.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">CREATORS CONTENT</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">CAMPAIGN INFORMATION SHARING</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">KOBE will manage the campaign as per information shared by clients in this brand fact sheet. By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">LOGISTICS ARRANGEMENT</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0 pb-2">It is recommended for our clients to make your own logistics arrangements.</p>
                  <p class="mb-0 pb-2">For clients that are unable to handle logistics, KOBE will offer complimentary logistics service for our clients with products (not including perishable goods or items that require special handling or storage) that are below 2kg and parcel size (length + width + height) does not exceed 120cm.</p>
                  <p class="mb-0 pb-2">Product has to be sent over to KOBE in 1 shipment before it is disseminated to the creators on your behalf.</p>
                  <p class="mb-0 pb-2">There will be a 5 working day turnaround for all logistics arrangements.</p>
                  <p class="mb-0">KOBE will not be responsible for any damaged or lost parcels.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">ADDITIONAL ENGAGEMENT</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0 pb-2">Kindly note that any additional engagements listed here are not applicable for KOBE Uncut campaigns and you could opt for Storytell campaign and are chargeable, kindly ensure that requirements are stated clearly with your Client Engagement Representative before launching of the campaign:</p>
                  <p class="mb-0 pb-2">● Contest giveaway on social media ● Photoshoot for client ● Video appearance in client’s own production ● Usage of photos/videos from creators as Ads online or offline ● Promo Code Shoutout ● Link in Bio/Swipe Up</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-layout wrap>
                    <v-flex :class="field.class ? field.class : 'xs12 md6'" v-for="(field, index) in brandSheetAOKFormSections.sectionOne.fields" :key="index">
                      <div>
                        <p class="h4 font-weight-bold mb-2" v-if="field.label !== ''">{{field.label}} <span class="red--text" v-if="field.required">*</span></p>
                        <p v-else class="form-label"></p>
                        <p v-html="showFieldValue(brandSheet[field.name], field.name)" v-if="field.type !== 'file'"></p>
                        <div v-if="field.type === 'file' && brandSheet[field.name].length > 0">
                          <v-row>
                            <v-col cols="12" sm="12" md="2" lg="1" v-for="(item, index) in brandSheet[field.name]" :key="index" align="center">                   
                              <a v-if="item.type.indexOf('pdf') !== -1" :href="item.url" target="_blank">
                                <v-img
                                    width="67" height="85"
                                    src="/static/img/pdf.png"
                                    aspect-ratio="1"
                                  ></v-img>
                              </a>                                                                                                               
                              <a v-if="item.type.indexOf('ppt') !== -1" :href="item.url" target="_blank">
                                <v-img
                                    width="67" height="85"
                                    src="/static/img/ppt.png"
                                  ></v-img>
                              </a>
                              <a v-if="item.type.indexOf('doc') !== -1" :href="item.url" target="_blank">
                                <v-img
                                    width="67" height="85"
                                    src="/static/img/doc.png"
                                  ></v-img>
                              </a>
                              <a v-if="item.type.indexOf('text') !== -1" :href="item.url" target="_blank">
                                <v-img
                                    width="67" height="85"
                                    src="/static/img/text.png"
                                  ></v-img>
                              </a>     
                              <a v-if="item.type.indexOf('image') !== -1" :href="item.url" target="_blank">
                                <v-img                   
                                  width="67"
                                  height="85"
                                  :src="item.url"
                                  :lazy-src="item.url"                                  
                                  class="grey lighten-2"
                                  aspect-ratio="1"
                                ></v-img>
                              </a>              
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row>
              <!-- End Section One -->

              <!-- <v-row>
                <v-col>
                  <v-btn :disabled="submitting" class="secondary" x-large @click.prevent="submitBrandSheet">
                    <i class="fa fa-circle-o-notch fa-spin" v-if="submitting"></i>
                    Submit
                  </v-btn>
                </v-col>
              </v-row> -->
              <!-- <v-row>
                <v-col>
                </v-col>
              </v-row> -->
            </v-flex>
          </v-layout>
          <!-- End AOK -->

          <!-- Start Kobe Lite -->
          <v-layout wrap justify-center mb-2 v-if="isKobeLite">
            <v-flex xs12 md7 class="content">
              <v-row>
                <v-col cols="12" class="pb-0">
                  <div class="avatar-logo">
                    <img :src="brandSheetLogo" alt="Logo" />
                  </div>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <h2 class="form-title">KOBE Lite - BRAND FACT SHEET</h2>
                </v-col>
              </v-row>
              <v-row class="mb-4">
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">{{brandSheetKobeLiteFormSections.sectionOne.title}}</p>
                </v-col>
              </v-row>
              <!-- <v-row class="mb-4">
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">{{brandSheetKobeLiteFormSections.sectionOne.subtitle}}</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-img src="/static/img/brand_sheet/aok_bg.png" ></v-img>
                </v-col>
              </v-row> -->
              <!-- Start Section One -->
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">LEAD TIME</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">14 days upon receiving this brand fact sheet and logistics from the client.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">TIME/DATE OF PUBLISH</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">Creators are free to post at any preferred time and day during the campaign period.</p>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">SELECTION CRITERIA</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0 pb-2">Profiles proposed will be screened for audience credibility on KOBE Patented Influencer Management System (IMS)</p>
                  <p class="mb-0">For niche requirements (for example, ethnicity, professions) , please opt for storytell packages instead.</p>
                </v-col>
              </v-row> -->
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">CREATORS CONTENT</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">CAMPAIGN INFORMATION SHARING</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-layout wrap>
                    <v-flex :class="field.class ? field.class : 'xs12 md6'" v-for="(field, index) in brandSheetKobeLiteFormSections.sectionOne.fields" :key="index">
                      <div>
                        <p class="h4 font-weight-bold mb-2" v-if="field.label !== ''">{{field.label}} <span class="red--text" v-if="field.required">*</span></p>
                        <p v-else class="form-label"></p>
                        <p v-html="showFieldValue(brandSheet[field.name], field.name)" v-if="field.type !== 'file'"></p>
                        <div v-if="field.type === 'file' && brandSheet[field.name].length > 0">
                          <v-row>
                            <v-col cols="12" sm="12" md="2" lg="1" v-for="(item, index) in brandSheet[field.name]" :key="index" align="center">                   
                              <a v-if="item.type.indexOf('pdf') !== -1" :href="item.url" target="_blank">
                                <v-img
                                    width="67" height="85"
                                    src="/static/img/pdf.png"
                                    aspect-ratio="1"
                                  ></v-img>
                              </a>                                                                                                               
                              <a v-if="item.type.indexOf('ppt') !== -1" :href="item.url" target="_blank">
                                <v-img
                                    width="67" height="85"
                                    src="/static/img/ppt.png"
                                  ></v-img>
                              </a>
                              <a v-if="item.type.indexOf('doc') !== -1" :href="item.url" target="_blank">
                                <v-img
                                    width="67" height="85"
                                    src="/static/img/doc.png"
                                  ></v-img>
                              </a>
                              <a v-if="item.type.indexOf('text') !== -1" :href="item.url" target="_blank">
                                <v-img
                                    width="67" height="85"
                                    src="/static/img/text.png"
                                  ></v-img>
                              </a>     
                              <a v-if="item.type.indexOf('image') !== -1" :href="item.url" target="_blank">
                                <v-img                   
                                  width="67"
                                  height="85"
                                  :src="item.url"
                                  :lazy-src="item.url"                                  
                                  class="grey lighten-2"
                                  aspect-ratio="1"
                                ></v-img>
                              </a>              
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row>
              <!-- End Section One -->

              <!-- <v-row>
                <v-col>
                  <v-btn :disabled="submitting" class="secondary" x-large @click.prevent="submitBrandSheet">
                    <i class="fa fa-circle-o-notch fa-spin" v-if="submitting"></i>
                    Submit
                  </v-btn>
                </v-col>
              </v-row> -->
              <!-- <v-row>
                <v-col>
                </v-col>
              </v-row> -->
            </v-flex>
          </v-layout>
          <!-- End Kobe Lite -->

          <!-- Start UGC -->
          <v-layout wrap justify-center mb-2 v-if="isUGC">
            <v-flex xs12 md7 class="content">
              <v-row>
                <v-col cols="12" class="pb-0">
                  <div class="avatar-logo">
                    <img :src="brandSheetLogo" alt="Logo" />
                  </div>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <h2 class="form-title">UGC (User-Generated-Content) Videos Application Form</h2>
                </v-col>
              </v-row>
              <!-- <v-row class="mb-4">
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">{{brandSheetAOKFormSections.sectionOne.title}}</p>
                </v-col>
              </v-row> -->
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h5 font-weight-bold mb-0">I am aware that kobe’s full service of S$15k and up, includes:</p>
                  <p>
                    <ul>
                      <li>Marketing goal, objective, and influence strategy consultation, incorporating the availability heuristic, bandwagon effect, and clustering effect for cognitive and emotive influence.</li>
                      <li>Development of social media content concepts and strategies using 7X award-winning A.U.D.I framework.</li>
                      <li>Curated creator identification through patented proprietary software, unveiling deep insights into social performance, audience demographics, and creator interest and personality profiling.</li>
                      <li>Comprehensive creator relationship management services, including content curation, quality assurance, vetting and scheduling.</li>
                      <li>Tailored content direction and brief design aligned with marketing objectives, encompassing recommendations for hashtags, captions, content direction, platform selection, optimal timing, and social SEO optimization.</li>
                      <li>Up to 3 accesses to our Influencer Management System® to streamline influencer campaign management.</li>
                      <li>Access to dedicated account managers, strategy planners, and community curators, providing expert recommendations and support.</li>
                    </ul>
                  </p>
                  <p>Lead time: 4 weeks</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">To proceed with UGC videos application, please complete the following.</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  {{brandSheet.ugcVideo}}
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p><strong>Includes:</strong></p>
                  <p>
                    <ul>
                      <li>Utilization and exposure to a nano-reviewer base of 10,000 individuals with follower counts up to 3,000.</li>
                      <li>Guidance and assistance in the creation of email invitations for reviewer outreach and engagement.</li>
                      <li>Immediate notifications when content is posted, with seamless collection of content assets for future use.</li>
                      <li>Direct access to reviewer contact information for the purpose of building relationships and facilitating additional collaborations.</li>
                    </ul>
                  </p>
                </v-col>
              </v-row>
              <v-row class="mb-4">
                <!-- <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">{{brandSheetAOKFormSections.sectionOne.subtitle}}</p>
                </v-col> -->
                <v-col cols="12" class="pb-0">
                  <v-img src="https://uat.app.getkobe.com/static/img/brand_sheet/ugc_process.png" ></v-img>
                </v-col>
              </v-row>
              <!-- Start Section One -->
              <!-- <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">LEAD TIME</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">14 days upon receiving this brand fact sheet and logistics from the client.</p>
                </v-col>
              </v-row> -->
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">TIME/DATE OF PUBLISH</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">Creators are free to post at any preferred time and day during the campaign period.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">INFLUENCER SELECTION</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0 pb-2">Influencer selection is interest and response based. Based on what you complete within this form, the information will be distributed to 10,000 individuals with follower counts up to 3,000. The interested recipients will respond accordingly.You are not allowed to modify the requirements of creator quality, quantity, specification.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">CREATORS CONTENT</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">INFORMATION SHARING</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">KOBE will manage the campaign as per information shared by clients in this brand fact sheet. By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">LOGISTICS ARRANGEMENT</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="h4 mb-0">For products</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <ul>
                    <li>It is recommended for our clients to make your own logistics arrangements.</li>
                    <li>For clients that are unable to handle logistics, KOBE will offer complimentary logistics service for our clients with products (not including perishable goods or items that require special handling or storage) that are below 2kg and parcel size (length + width + height) does not exceed 120cm.</li>
                    <li>Product has to be sent over to KOBE in 1 shipment before it is disseminated to the creators on your behalf.</li>
                    <li>There will be a 5 working day turnaround for all logistics arrangements.</li>
                    <li>KOBE will not be responsible for any damaged or lost parcels.</li>
                  </ul>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="h4 mb-0">For experience</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <ul>
                    <li>Creator attend the experience directly and client to verify</li>
                    <li>Creator can make the purchase of experience with attached receipt for 100% reimbursement from client</li>
                  </ul>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">UGC VIDEOS TRACKING</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0 pb-2">You will receive email notification via your email address provided below each time a creator submits their content. The campaign concludes once the number of UGC videos achieves the number agreed.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">POST CAMPAIGN</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0 pb-2">You will have direct access to creator contact information for the purpose of relationship building, additional collaborations. Kobe will assume a non-interventionist role and will not levy any charges or engage in mediation with respect to the relationship. You are granted unrestricted discretion to communicate and negotiate according to your preferences.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-layout wrap>
                    <v-flex :class="field.class ? field.class : 'xs12 md6'" v-for="(field, index) in brandSheetAOKFormSections.sectionOne.fields" :key="index">
                      <div>
                        <p class="h4 font-weight-bold mb-2" v-if="field.label !== ''">{{field.label}} <span class="red--text" v-if="field.required">*</span></p>
                        <p v-else class="form-label"></p>
                        <p v-html="showFieldValue(brandSheet[field.name], field.name)" v-if="field.type !== 'custom'"></p>
                        <div v-if="field.name === 'sampleVideoContent'">
                          <p v-html="brandSheet.sampleVideoContent" v-if="typeof brandSheet.sampleVideoContent === 'string'"></p>
                          <v-row class="mb-3" v-if="typeof brandSheet.sampleVideoContent === 'object'">
                            <v-col class="pb-0" cols="12" sm="12" md="12" lg="12" v-for="(item, index) in brandSheet.sampleVideoContent" :key="index" align="left">
                              <a :href="item.link" target="_blank">
                                {{item.link}}
                              </a>              
                            </v-col>
                          </v-row>
                          <div v-if="brandSheet.sampleVideoContentFiles.length > 0">
                            <v-row>
                              <v-col cols="12" sm="12" md="12" lg="12" v-for="(item, index) in brandSheet.sampleVideoContentFiles" :key="index" align="left">
                                <a :href="item.url" target="_blank">
                                  Click to View
                                </a>              
                              </v-col>
                            </v-row>
                          </div>
                        </div>
                        <div v-if="field.name === 'marketingCollaterals'">
                          <p v-html="brandSheet.marketingURL" v-if="typeof brandSheet.marketingURL === 'string'"></p>
                          <v-row class="mb-3" v-if="typeof brandSheet.marketingURL === 'object'">
                            <v-col class="pb-0" cols="12" sm="12" md="12" lg="12" v-for="(item, index) in brandSheet.marketingURL" :key="index" align="left">
                              <a :href="item.link" target="_blank">
                                {{item.link}}
                              </a>              
                            </v-col>
                          </v-row>
                          <div v-if="brandSheet.marketingCollaterals.length > 0">
                            <v-row>
                              <v-col cols="12" sm="12" md="2" lg="1" v-for="(item, index) in brandSheet.marketingCollaterals" :key="index" align="center">                   
                                <a v-if="item.type.indexOf('pdf') !== -1" :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/pdf.png"
                                      aspect-ratio="1"
                                    ></v-img>
                                </a>                                                                                                               
                                <a v-if="item.type.indexOf('ppt') !== -1" :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/ppt.png"
                                    ></v-img>
                                </a>
                                <a v-if="item.type.indexOf('doc') !== -1" :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/doc.png"
                                    ></v-img>
                                </a>
                                <a v-if="item.type.indexOf('text') !== -1" :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/text.png"
                                    ></v-img>
                                </a>     
                                <a v-if="item.type.indexOf('image') !== -1" :href="item.url" target="_blank">
                                  <v-img                   
                                    width="67"
                                    height="85"
                                    :src="item.url"
                                    :lazy-src="item.url"                                  
                                    class="grey lighten-2"
                                    aspect-ratio="1"
                                  ></v-img>
                                </a>              
                              </v-col>
                            </v-row>
                          </div>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row>
              <!-- End Section One -->

              <!-- <v-row>
                <v-col>
                  <v-btn :disabled="submitting" class="secondary" x-large @click.prevent="submitBrandSheet">
                    <i class="fa fa-circle-o-notch fa-spin" v-if="submitting"></i>
                    Submit
                  </v-btn>
                </v-col>
              </v-row> -->
              <!-- <v-row>
                <v-col>
                </v-col>
              </v-row> -->
            </v-flex>
          </v-layout>
          <!-- End UGC -->
        </v-form>
      </v-container>
    </v-card>
    </v-dialog>
  </div>
</template>
<script>
import campaignConfig from './config';
import logoDataURL from '@/config/logoDataURL'
// import config from '@/config';
export default {
  name: 'ViewBrandSheetModal',
  props: {
    value: Boolean,
    brandSheetData: Object
  },
  data () {
    return {
      campaignTypes: campaignConfig.campaignType,
      bfsTypes: campaignConfig.bfsTypes,
      brandSheetFormSections: campaignConfig.brandSheetFormSections,
      brandSheetAOKFormSections: campaignConfig.brandSheetAOKFormSections,
      brandSheetKobeLiteFormSections: campaignConfig.brandSheetKobeLiteFormSections,
      userGenderDisplay: campaignConfig.userGenderDisplay,
      brandSheetLogo: logoDataURL.logo || '/static/img/kobe_bg_main.png',
      brandSheet: {}
    }
  },
  computed: {
    currentUserID: function() {
      return this.$store.state.user.id;
    },
    isUGC: function() {
      return this.brandSheet.type === this.bfsTypes.UGC || this.brandSheet.ugcVideo
    },
    isStoryTell: function() {
      return this.brandSheet.type === this.campaignTypes.STORY_TELL
    },
    isAOK: function() {
      return this.brandSheet.type === this.campaignTypes.AOK || this.brandSheet.type === this.campaignTypes.Uncut || this.brandSheet.type === this.bfsTypes.AOK
    },
    isKobeLite: function() {
      return this.brandSheet.type === this.bfsTypes.KOBE_LITE
    }
  },
  methods: {
    close() {
      this.$emit('input');
    },
    showFieldValue(value, name) {
      if (name === 'mobilePhone') {
        return ''
      }
      if (name === 'gender') {
        let result = this.userGenderDisplay.find(u => u.value === value)
        if (result) {
          return result.text
        }
      }
      if (name === 'mobileCountry') {
        return this.brandSheet.mobilePhone
      }
      if (name === 'campaignBudget') {
        if (this.brandSheet.budgetCurrency) {
          return `${this.brandSheet.budgetCurrency} ${this.brandSheet.campaignBudget}`
        } else {
          return this.brandSheet.campaignBudget
        }
      }
      if (Array.isArray(value)) {
        if (value.length === 0) {
          return '-'
        }
        return value.join(', ')
      }
      if (name === 'sampleVideoContent') {
        return value || ''
      }
      return value || '-'
    }
  },
  watch: {
    brandSheetData: function(newBrandSheetData) {
      this.brandSheet = newBrandSheetData
    }
  }
}
</script>
<style scoped>
  .brand-fact-sheet-view-card {
    display: flex;
    flex-direction: column;
    height: 100vh;
    max-height: 100vh;
    overflow: hidden;
  }

  .brand-fact-sheet-view-card > .v-toolbar {
    flex: 0 0 auto;
  }

  .brand-fact-sheet-view-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
  }

  .background-soft-grey {
    background-color: #f6f6f6;
  }

  .v-text-field-sm{
    width: 320px;
  }

  .td-error {
    margin-bottom: -20px;
    right: 16px;
  }

  .checkboxes-error {
    margin-top: -15px;
  }

  .td-title {
    font-weight: bold;
    margin-bottom: 1px;
  }

  .avatar-logo {
    width: 120px;
    margin: 0 auto;
    line-height: 0;
  }

  .avatar-logo img {
    display: block;
    width: 100%;
    height: auto;
  }

  .form-title {
    margin-top: 0;
    text-align: center;
    font-weight: 600;
    /* padding: 40px; */
    transition: all 0.5s ease-out;
  }
</style>



// WEBPACK FOOTER //
// ViewBrandSheetModal.vue?c9a593a8